<template>
  <div class="fuel-cut-control" v-if="showFuelCut">
    <div class="card">
      <div class="card-header" data-background-color="magenta-dark">
        <h4>Corte de combustible</h4>
      </div>

      <div class="card-content">
        <button
          type="button"
          @click="toggle()"
          :disabled="active"
          class="btn btn-primary"
        >
          Cortar suministro
        </button>
        <button
          type="button"
          @click="toggle()"
          :disabled="!active"
          class="btn"
          style="background: #83c554"
        >
          Restablecer suministro
        </button>
        <div style="border-left: 1px solid grey; margin: 0 10px; height: 70px"></div>
        <div class="state-container">
          <span class="title"> {{ activeLabel }} </span>
          <spinner v-if="running"/>
          <img v-else width="64px" :src="activeIcon" alt="fuel"/>
        </div>
      </div>
    </div>

    <yes-no-modal
      :show="showModal === modalTypes.Activate"
      :title="`¿Está seguro que desea ${this.active ? 'desactivar' : 'activar'} el corte de combustible?`"
      @pressed-no="hideModal()"
      @pressed-yes="executeAction()"
    >
      <p> De hacerlo, el vehículo <b>{{this.active ? 'podrá volver a' : 'no podrá'}}</b> circular. </p>
    </yes-no-modal>

    <info-modal
      :show="showModal === modalTypes.Running"
      @pressed-ok="hideModal()"
      :title="`${this.active ? 'Desactivando' : 'Activando'} corte de combustible...`"
    >
      <spinner />
    </info-modal>

    <info-modal
      :show="showModal === modalTypes.Error"
      @pressed-ok="hideModal()"
      :title="`Ha ocurrido un error al ${this.active ? 'desactivat' : 'activar'} el corte de combustible...`"
    >
      {{ errorMessage }}
    </info-modal>
  </div>
</template>

<script>
import YesNoModal from './YesNoModal.vue'
import InfoModal from './InfoModal.vue'
import Spinner from 'vue-simple-spinner'
import { ThingActionState, VehicleAction } from '../../constants'
import ThingsService from '../../thingsService.js'

const modalTypes = Object.freeze({
  Activate: 'activate',
  Running: 'running',
  Error: 'error'
});

const query = `state=='${ThingActionState.Running}' AND (action=='${VehicleAction.FuelCutOff}' OR action=='${VehicleAction.FuelRestore}')&_sort=created_timestamp%2Bdesc`;

export default {
  components: {
    YesNoModal,
    InfoModal,
    Spinner
  },

  props: {
    vehicle: Object,
  },

  data: () => ({
    running: false,
    showModal: null,
    pollingInterval: null,
    errorMessage: '',
    modalTypes,
  }),

  computed: {
    active() {
      return this.vehicle.state.fuel_cut_off
    },

    activeIcon() {
      return this.active ? "static/img/fuel-cut.png" : "static/img/fuel-ok.png"
    },

    activeLabel() {
      if (this.running) {
        return this.active ? "Restaurando..." : "Cortando...";
      }
      return 'Estado'
    },

    showFuelCut() {
      return this.vehicle.actions != null &&
        this.vehicle.actions.includes(VehicleAction.FuelCutOff) &&
        this.vehicle.actions.includes(VehicleAction.FuelRestore)
    }
  },

  mounted() {
    this.checkActionRunning()
  },

  beforeDestroy() {
    this.cancelInterval()
  },

  methods: {
    toggle() {
      this.showModal = this.running ? modalTypes.Running : modalTypes.Activate
    },

    hideModal() {
      this.showModal = null
      this.errorMessage = ''
    },

    async checkActionRunning() {
      const actions = await ThingsService.getActions(this.vehicle.id, query)
      if (actions.length > 0) {
        this.pollAction(actions[0].id)
      }
    },

    async executeAction() {
      try {
        const action = await ThingsService.executeAction(this.vehicle.id, this.active ? VehicleAction.FuelRestore : VehicleAction.FuelCutOff, { code: '1234' })
        this.pollAction(action.id)
        this.hideModal()
      } catch (error) {
        this.errorMessage = 'Ha ocurrido un error al intentar ejecutar el comando. Por favor intente de nuevo en unos segundos.'
        this.showModal = modalTypes.Error
      }
    },

    pollAction(executionId) {
      this.running = true
      this.pollingInterval = setInterval(async () => {
        this.running = true
        const action = await ThingsService.getAction(this.vehicle.id, executionId)
        if (action.state !== ThingActionState.Running) {
          // Give the backend time to refresh the car state
          setTimeout(() => {
            if (action.state === ThingActionState.Finished) {
              this.$emit('execution-finished')
            }

            this.cancelInterval()
            this.hideModal()

            if (action.state === ThingActionState.Error) {
              this.errorMessage = action.result.details
              this.showModal = modalTypes.Error
            }
          }, 3000)
        }
      }, 5000);
    },

    cancelInterval() {
      this.running = false;
      if (this.pollingInterval != null) {
        clearInterval(this.pollingInterval)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.fuel-cut-control {
  display: flex;
  margin-left: 10px;
  margin-right: 10px;

  .card {
    display: flex;
    flex-direction: column;
  }

  .card-content {
    display: flex;
    height: 100%;
    align-items: center;

    >button {
      margin: 0 5px !important;
      height: 50px;
      border-radius: 20px;
    }
  }

  .title {
    text-align: center;
    font-weight: bold;
  }

  .active-label {
    min-width: 50px;
    font-weight: bold;
  }

  .state-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100px;
    &>img {
      width: 48px;
    }
  }
}

.modal-mask {
  color: black;
}
</style>



// WEBPACK FOOTER //
// FuelCut.vue?23b1bb8c